import type { Permission } from '@prism/contracts';

/** Anything that carries the signed-in person's effective permissions (useMe().data, or a bare list in tests). */
export type HasPermissions = { permissions: readonly Permission[] } | readonly Permission[] | null | undefined;

const list = (me: HasPermissions): readonly Permission[] => (!me ? [] : Array.isArray(me) ? me : (me as { permissions: readonly Permission[] }).permissions);

/** Whether the person has the permission: `can(me, 'storage.manage')`. Nothing loaded yet is no permission. */
export function can(me: HasPermissions, p: Permission): boolean {
  return list(me).includes(p);
}

/** Whether the person has at least one of the permissions. */
export function canAny(me: HasPermissions, ps: readonly Permission[]): boolean {
  const have = list(me);
  return ps.some((p) => have.includes(p));
}
